import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { useNavigate, useLocation } from "react-router-dom";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import FunctionButton from "../../components/common/FunctionButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import ProgressWrapDiv from "../../components/common/ProgressWrapDiv";
import InputWrapDiv from "../../components/common/InputWrapDiv";
import ContentInput from "../../components/common/ContentInput";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import TopBoxDiv from "../../components/common/TopBoxDiv";
import ValidMsgSpan from "../../components/common/ValidMsgSpan";
import MessageDialog from "../../components/common/MessageDialog";
import { useTranslation } from "react-i18next";

const RegRequiredInfoPage = () => {
  const navigate = useNavigate();
  const rLocation = useLocation();
  const { t } = useTranslation();
  const verifyEmail =
    /([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

  const waUserId = rLocation.state?.waUserId || null;
  const waPwd = rLocation.state?.waPwd || null;
  const united = rLocation.state?.united || null;
  const country = rLocation.state?.country || null;
  const location = rLocation.state?.location || null;
  const loc = rLocation.state?.loc || null;

  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [email, setEmail] = useState("");
  const [lang, setLang] = useState("");
  const [inspAuth, setInspAuth] = useState("");
  const [inspAuthDesc, setInspAuthDesc] = useState("");
  const [menuAuth, setMenuAuth] = useState("");

  const [checkUserId, setCheckUserId] = useState(false);
  const [checkEmail, setCheckEmail] = useState(false);

  const [dialogMsg, setDialogMsg] = useState("");
  const [dialogMsg2, setDialogMsg2] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpen2, setIsDialogOpen2] = useState(false);

  const sbLanguage = [
    { code: "", codeDesc: t("L0657") },
    { code: "ENG", codeDesc: t("L0899") },
  ];
  const sbMenuAuth = [
    { code: "", codeDesc: t("L0392") },
    { code: "MNG", codeDesc: t("L0440") },
    { code: "INSP", codeDesc: t("L0156") },
  ];

  useEffect(() => {
    if (!united || !location || !loc || !country) {
      navigate("/login");
    }

    api
      .post("/user/code/auth", {
        sCountry: country,
        sType: location,
        sLocCode: loc,
      })
      .then((response) => {
        if (
          !response.data ||
          response.data.length === 0 ||
          !response.data[0].code
        ) {
          navigate("/login");
        }
        setInspAuth(response.data[0].code);
        setInspAuthDesc(response.data[0].codeDesc);
      })
      .catch(() => {
        //TODO
      });
  }, []);

  const handleUserIdChange = (e) => {
    setUserId(e.target.value.trim());
    setCheckUserId(false);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value.trim());
    setCheckEmail(false);
  };

  const handleLangChange = (e) => {
    setLang(e.target.value);
  };

  const handleMenuAuthChange = (e) => {
    setMenuAuth(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handlePasswordConfirmChange = (e) => {
    setPasswordConfirm(e.target.value);
  };

  const handleIdCheckClick = () => {
    if (!userId) {
      setDialogMsg(t("L0001"));
      setIsDialogOpen(true);
      return;
    }

    api
      .post("/user/idcheck", {
        userId: userId,
      })
      .then((response) => {
        if (response.data === 0) {
          setDialogMsg(t("L0013"));
          setIsDialogOpen(true);
          setCheckUserId(true);
        } else {
          setDialogMsg(t("L0014"));
          setIsDialogOpen(true);
        }
      })
      .catch(() => {
        //TODO
      });
  };

  const handleEmailCheckClick = () => {
    if (!email) {
      setDialogMsg(t("L0023"));
      setIsDialogOpen(true);
      return;
    }

    if (!verifyEmail.test(email)) {
      setDialogMsg(t("L0024"));
      setIsDialogOpen(true);
      return;
    }

    api
      .post("/user/emailcheck", {
        email: email,
      })
      .then((response) => {
        if (response.data === 0) {
          setDialogMsg(t("L0021"));
          setIsDialogOpen(true);
          setCheckEmail(true);
        } else {
          setDialogMsg(t("L0022"));
          setIsDialogOpen(true);
        }
      })
      .catch(() => {
        //TODO
      });
  };

  const handleConfirm = () => {
    setIsDialogOpen(false);
    setDialogMsg("");
  };

  const handleConfirm2 = () => {
    setIsDialogOpen2(false);
    setDialogMsg2("");
    navigate("/join/reg-org");
  };

  const handlePreviousClick = () => {
    navigate(-1);
  };

  const handleNextClick = () => {
    if (!validate()) {
      return;
    }

    api
      .post("/user/signup", {
        waUserId: waUserId,
        waPwd: waPwd,
        userId: userId,
        userPwd: password,
        email: email,
        lang: lang,
        location: location,
        united: united,
        country: country,
        loc: loc,
        authType: inspAuth,
        menuAuth: menuAuth,
      })
      .then(() => {
        navigate("/join/reg-confirm", {
          state: {
            email: email,
          },
        });
      })
      .catch((error) => {
        if (error.response.data.result == "1034") {
          setDialogMsg(t("L0259"));
          setIsDialogOpen(true);
        } else if (error.response.data.result == "1035") {
          setDialogMsg(t("L0260"));
          setIsDialogOpen(true);
        } else {
          setDialogMsg("Sorry. Fail to make your account. ");
          setIsDialogOpen(true);
        }
      });
  };

  const [errors, setErrors] = useState({
    validUserId: "",
    validPassword: "",
    validPasswordConfirm: "",
    validEmail: "",
    validLang: "",
    validMenuAuth: "",
  });

  const validate = () => {
    let tempErrors = {};
    let isValid = true;
    let regex = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-_])(?=.*[0-9]).{8,20}$/;

    if (!location || !united || !country || !loc || !inspAuth) {
      setDialogMsg2("There is missing information.");
      setIsDialogOpen2(true);
    }

    if (!userId || !checkUserId) {
      tempErrors.validUserId = "User ID is required.";
      isValid = false;
    }

    if (!password) {
      tempErrors.validPassword = t("L0042");
      isValid = false;
    } else if (!regex.test(password)) {
      tempErrors.validPassword = t("L0018");
      isValid = false;
    }

    if (!passwordConfirm) {
      tempErrors.validPasswordConfirm = t("L0042");
      isValid = false;
    } else if (password !== passwordConfirm) {
      tempErrors.validPasswordConfirm = t("L0042");
      isValid = false;
    }

    if (!email || !checkEmail) {
      tempErrors.validEmail = "Email is required.";
      isValid = false;
    }

    if (!lang) {
      tempErrors.validLang = "Language is required.";
      isValid = false;
    }

    if (!menuAuth) {
      tempErrors.validMenuAuth = "Menu Authority Level is required.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("L0341"), t("L0342")]}></BreadCrumbDiv>
      <ProgressWrapDiv>
        <li>{`01 ${t("L0344")}`}</li>
        <li className="active">{`02 ${t("L0345")}`}</li>
        <li>{`03 ${t("L0346")}`}</li>
      </ProgressWrapDiv>

      <InputWrapDiv>
        <TopBoxDiv value={t("L0357")}></TopBoxDiv>
        <table>
          <tbody>
            <tr>
              <th>
                {t("L0185")}
                {errors.validUserId && (
                  <>
                    <br />
                    <ValidMsgSpan value={errors.validUserId}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  value={userId}
                  width="100%"
                  maxLength={250}
                  placeholder={t("L0185")}
                  onChange={handleUserIdChange}
                ></ContentInput>
              </td>
              <td style={{ width: "80px" }}>
                <FunctionButton
                  value={t("L0359")}
                  className="small"
                  onClick={handleIdCheckClick}
                ></FunctionButton>
              </td>
            </tr>
            <tr>
              <th>
                {t("L0027")}
                {errors.validPassword && (
                  <>
                    <br />
                    <ValidMsgSpan value={errors.validPassword}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  type="password"
                  value={password}
                  width="100%"
                  maxLength={250}
                  placeholder={t("L0027")}
                  onChange={handlePasswordChange}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                {t("L0027")} {t("L0004")}
                {errors.validPasswordConfirm && (
                  <>
                    <br />
                    <ValidMsgSpan
                      value={errors.validPasswordConfirm}
                    ></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  type="password"
                  value={passwordConfirm}
                  width="100%"
                  maxLength={250}
                  placeholder={`${t("L0027")} ${t("L0004")}`}
                  onChange={handlePasswordConfirmChange}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>{t("L0360")}</th>
              <td>
                <ContentInput
                  value={location}
                  width="100%"
                  disabled={true}
                  maxLength={100}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>{t("L0051")}</th>
              <td>
                <ContentInput
                  value={loc}
                  width="100%"
                  maxLength={64}
                  disabled={true}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                {t("L0363")}
                {errors.validEmail && (
                  <>
                    <br />
                    <ValidMsgSpan value={errors.validEmail}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  value={email}
                  width="100%"
                  maxLength={250}
                  placeholder={t("L0363")}
                  onChange={handleEmailChange}
                ></ContentInput>
              </td>
              <td style={{ width: "80px" }}>
                <FunctionButton
                  value={t("L0359")}
                  className="small"
                  onClick={handleEmailCheckClick}
                ></FunctionButton>
              </td>
            </tr>
            <tr>
              <th>
                {t("L0657")}
                {errors.validLang && (
                  <>
                    <br />
                    <ValidMsgSpan value={errors.validLang}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <CodeSelectBox
                  value={lang}
                  codes={sbLanguage}
                  onChange={handleLangChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="100%"
                  style={{
                    backgroundColor: "#f6f3f2",
                  }}
                />
              </td>
            </tr>
            <tr>
              <th>{t("L0107")}</th>
              <td>
                <ContentInput
                  value={inspAuthDesc}
                  width="100%"
                  maxLength={64}
                  disabled={true}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                {t("L0392")}
                {errors.validMenuAuth && (
                  <>
                    <br />
                    <ValidMsgSpan value={errors.validMenuAuth}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <CodeSelectBox
                  value={menuAuth}
                  codes={sbMenuAuth}
                  onChange={handleMenuAuthChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="100%"
                  style={{
                    backgroundColor: "#f6f3f2",
                  }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </InputWrapDiv>

      <ButtonWrapDiv className="btn_bottom">
        <FunctionButton
          className="big bg_gray"
          value={t("L0354")}
          onClick={handlePreviousClick}
        ></FunctionButton>

        <FunctionButton
          className="big"
          value={t("L0355")}
          onClick={handleNextClick}
        ></FunctionButton>
      </ButtonWrapDiv>

      {isDialogOpen && (
        <MessageDialog title={t("L0339")} message={dialogMsg}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}

      {isDialogOpen2 && (
        <MessageDialog title={t("L0339")} message={dialogMsg2}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm2}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};

export default RegRequiredInfoPage;
